import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const getIPFSAsset = async ({
  ipfsHash,
  options,
}: {
  ipfsHash: string;
  options?: AxiosRequestConfig<any>;
}) => {
  const gatewayUrls = process.env.NEXT_PUBLIC_IPFS_GATEWAY?.split(', ');
  if (!gatewayUrls) return '';

  const controllers = gatewayUrls?.map(() => new AbortController());
  const requests: Promise<AxiosResponse<any, any>>[] = [];

  gatewayUrls?.forEach((url, id) => {
    requests.push(
      axios.get(`${url}/ipfs/${ipfsHash}`, {
        signal: controllers[id].signal,
        ...options,
      })
    );
  });
  const data = await Promise.any(requests);
  return data;
};

export const getIPFSGateWayURL = async () => {
  const gatewayUrls = process.env.NEXT_PUBLIC_IPFS_GATEWAY?.split(', ');
  if (!gatewayUrls) return '';

  const controllers = gatewayUrls?.map(() => new AbortController());

  gatewayUrls?.map(async (url, id) => {
    await axios.get(`${url}`, {
      signal: controllers[id].signal,
    });
    return url;
  });

  const data = await Promise.any(gatewayUrls);
  return data;
};
